import React from 'react';
import classNames from "classnames";

export function ColoredBox({children, title, theme, color, className}) {

    function setTheme() {
        if(theme != null) {
            return "bg-"+theme;
        }
        return null;
    }

    function setBorder() {
        if(theme != null) {
            return "border-"+theme;
        }
        return null;
    }

    const classes = classNames(setBorder()+" border border-3 rounded my-2 "+className,
        {

        }
    )

    return (
        <div className={classes}>

            <div className={setTheme()+ " text-white px-3 py-2"}>
                {title}
            </div>

            <div className={"p-3"}>
                {children}
            </div>
        </div>
    )

}